import { CurvedIcon, QuadraticIcon, StraightIcon } from "@/icons/line-types";

export const LINE_TYPES = {
    straight: StraightIcon,
    quadratic: QuadraticIcon,
    curved: CurvedIcon,
};
